"use strict";

exports.__esModule = true;
exports.getEstimateRedeemResult = getEstimateRedeemResult;
var _sdkCore = require("@acala-network/sdk-core");
var _exchangeRate = require("./exchange-rate");
function getEstimateRedeemResult(env, amount, isFastReddem) {
  if (isFastReddem) {
    const liquidToBurn = amount.mul(new _sdkCore.FixedPointNumber(1).sub(env.fastMatchFeeRate));
    const redeemStaking = (0, _exchangeRate.convertLiquidToStaking)(env.exchangeRate, liquidToBurn);
    const fee = amount.sub(liquidToBurn);
    return {
      request: amount,
      receive: redeemStaking,
      fee,
      canTryFastRedeem: env.toBondPool.gt(redeemStaking),
      env
    };
  }
  return {
    request: amount,
    receive: (0, _exchangeRate.convertLiquidToStaking)(env.exchangeRate, amount),
    fee: _sdkCore.FixedPointNumber.ZERO,
    canTryFastRedeem: false,
    env
  };
}